<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import Upgrade from './components/Upgrade.vue'

const curTab = ref('upgrade')
</script>

<template>
  <div class="smithy-page page">
    <h2>魔法工坊</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="升级" name="upgrade" class="pane" lazy>
        <Upgrade class="pane-item" />
      </el-tab-pane>
    </el-tabs>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.smithy-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
